export default __webpack_public_path__ + "static/28197-5cceb6b6554dab005af621a57f47bd47.jpg";